import React, { memo } from 'react';

interface TextInputProps {
    label: string;
    inputValue: string;
    placeholder?: string;
    onChange: (inputValue: string) => void;
    addedClass?: string;
    readonly?: boolean;
    errorMessage?: string;
}

const TextInput: React.FC<TextInputProps> = ({ label, inputValue, placeholder = '', onChange, addedClass, readonly, errorMessage }) => {
    console.log('------------     text input re-render    --------------', label, inputValue);

    return (
        <div className={`${addedClass}`}>
            <div className="w-full flex flex-col mb-[15px]">
                <label className="block text-base mb-[5px]" htmlFor="textInput">
                    {label}
                </label>
                <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => onChange(e.target.value)}
                    placeholder={placeholder}
                    className="light-border p-2 rounded"
                    style={{
                        border: errorMessage ? "1px solid #f56565" : "1px solid #ddd"
                    }}
                    readOnly={readonly}
                />
                {errorMessage && <div className="text-red-500 text-sm mt-1">{errorMessage}</div>}
            </div>
        </div>
    );
};

export default memo(TextInput);
